/**
 * Class to describe a poi
 */
export default class PointOfInterest {
  /**
   * Constructs a POI
   * @param {Unique ID} id
   * @param {label of POI} label
   * @param {sublabel of the POI} sublabel
   * @param {category of the POI} category
   * @param {highlight geometry of the POI} geometry
   * @param {meta data of the POI, contains all additional data} meta
   * @param {center coordinate of the POI} centerCoordinate
   */
  constructor(id, label, sublabel, category, geometry, meta, centerCoordinate) {
    this.id = id;
    this.label = label;
    this.sublabel = sublabel;
    this.meta = meta;
    this.geometry = geometry;
    this.category = category;
    this.centerCoordinate = centerCoordinate;
  }
}
